import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';

@Component({
  selector: 'app-detalhe-projeto-indicadores-meta-realizado',
  templateUrl: './detalhe-projeto-indicadores-meta-realizado.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-meta-realizado.component.scss']
})
export class DetalheProjetoIndicadoresMetaRealizadoComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  @Input() indicador: IndicadoresProjeto;
  indicadoresList: any;
  permission: any;
  status: any;
  viewIndicadores = { filho: false, exeAnt: false, somados: false };
  audit: AtualizacoesAudit;

  constructor(private myService: IndicadoresProjetoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.loading();
    this.addSub(
      this.myService.getListMetaRealizado(this.indicador?.id).subscribe({
        next: (res) => {
          this.indicadoresList = res['list'];
          this.permission = res['permission'];
          this.status = res['status'];
          this.processListData();
          this.graph(res['graph']);
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  processListData() {
    if (this.indicadoresList?.length) {
      this.getFormArray().clear();
      this.indicadoresList?.forEach((indicador) => {
        if (indicador?.type_indicador == 4) {
          indicador?.month?.forEach((item, index) => {
            this.getFormArray().push(this.createFormGroup(indicador?.list[index], index))
          })
        }
      })
    }
  }

  graph(value) {
    if (value) {
      this.indicador.chartOptions = {
        responsive: true,
      };
      this.indicador.chartLabels = [];
      this.indicador.chartData;
      this.indicador.chartType = value?.type_graph == 2 ? 'line' : 'bar';
      this.indicador.chartMeta = [];
      this.indicador.chartRealizado = [];

      value.itens.forEach((item, index) => {
        if (index != 0) {
          this.indicador.chartLabels.push(item[0]);
          this.indicador.chartMeta.push(item[1]);
          this.indicador.chartRealizado.push(item[2]);
        }
      })

      this.indicador.chartData = {
        labels: this.indicador.chartLabels,
        datasets: [
          {
            data: this.indicador.chartMeta,
            label: value.itens[0][1],
            pointRadius: 5,
            order: 1
          },
          {
            data: this.indicador.chartRealizado,
            label: value.itens[0][2],
            pointRadius: 5,
            order: 0
          },
        ],
      };
      console.log(this.indicador.chartData)
    }
    this.indicador.viewInfoActive = true;
  }

  initForm() {
    this.form = new FormGroup({
      row: new FormArray([]),
    });

    this.audit = {
      ind_table_id: this.entity.id
    };
  }

  createFormGroup(value = null, index = null): FormGroup {
    return new FormGroup({
      id: new FormControl(value?.id),
      ind_id: new FormControl(value?.ind_id || this.indicador?.id),
      month: new FormControl(value?.month),
      goal: new FormControl({ value: value?.goal, disabled: !this.permission?.canEditGoal }),
      done: new FormControl({ value: value?.done, disabled: !this.permission?.canEditDone }),
      numerator: new FormControl({ value: value?.numerator, disabled: !this.permission?.canEditNumerator }),
      denominator: new FormControl({ value: value?.denominator, disabled: !this.permission?.canEditDenominator }),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('row') as FormArray;
  }

  getDataCreate() {
    let data;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.updateMetaRealizado(this.getDataCreate(), this.indicador?.id).subscribe({
          next: (res) => {
            this.confirmation().subscribe(() => {
              this.initList();
            });
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  formatarMedidaFisica(index: number, field: string, ind: number = null) {
    let goalValue = this.getFormArray().controls[index].get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, this.indicador?.decimal_places);
    this.getFormArray().controls[index].get(field).setValue(value);
    if (field == "numerator" || field == "denominator") {
      this.numeratorDenominatorChange(index, ind);
    }
    this.statusChange(index, ind);
  }

  numeratorDenominatorChange(index: number, id: number) {
    let numerator = this.getFormArray().controls[index].get('numerator')?.value?.replace(/\./g, '')?.replace(',', '.');
    let denominator = this.getFormArray().controls[index].get('denominator')?.value?.replace(/\./g, '')?.replace(',', '.');
  
    let result: string | null = null;
  
    if (numerator === '' || denominator === '') {
      this.getFormArray().controls[index].get('done').setValue(null);
      return;
    }
  
    if (numerator === denominator) {
      result = Number(100).toFixed(this.indicador?.decimal_places);
    } else {
      if (+denominator > 0) {
        result = Number((+numerator * 100) / (+denominator)).toFixed(this.indicador?.decimal_places);
      } else {
        result = Number(0).toFixed(this.indicador?.decimal_places);
      }
    }
    const value = result ? this.maskService.formatarMedidaFisica(result, this.indicador?.decimal_places) : null;
    this.getFormArray().controls[index].get('done').setValue(value);
  }


  statusChange(index: number, ind: number) {
    let done = this.getFormArray().controls[index].get('done')?.value?.replace('.', '')?.replace(',', '.');
    let goal = this.getFormArray().controls[index].get('goal')?.value?.replace('.', '')?.replace(',', '.');
    let polarity = this.indicador?.polarity_id;
    let statOk = this.status?.status_ok;
    let statWarn = this.status?.status_warn;
    let value = 0;
    let status = '<span class="ind-status ind-status-0"></span>';

    if (done == goal) {
      status = '<span class="ind-status ind-status-1"></span>'
    }
    if (polarity) {
      value = goal == 0 && done == 0? 100 : (done * 100) / (goal == 0 ? 0.0001 : goal);
    } else {
      value = 100 - ((done - goal) * 100) / (goal == 0 ? 0.0001 : goal);
    }
    if (value >= statOk) {
      status = '<span class="ind-status ind-status-1"></span>';
    } else if (value >= statWarn) {
      status = '<span class="ind-status ind-status-2"></span>';
    } else {
      status = '<span class="ind-status ind-status-3"></span>';
    }
    if (done == '' || goal == '') {
      status = '<span class="ind-status ind-status-0"></span>'
    }
    this.indicadoresList[ind].list[index].sum_status1 = status;
  }
}
